import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import infoSvg from '../../assets/imgs/info.svg';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  dialogHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  dialogTitle: {
    fontSize: 20,
    color: 'dialogTitle',
    fontWeight: 'bold',
    padding: theme.spacing(2, 0),
  },
  dialogDescription: {
    fontSize: 14,
    color: theme.palette.neutrals.low.medium,
  },
  dialogActions: {
    padding: theme.spacing(4, 0),
    justifyContent: 'center',
  },
}));

function DialogImagine({ open, onClose, title, description, children }) {
  const classes = useStyles();
  const theme = useTheme();

  function handleCloseDialog() {
    onClose();
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogContent>
        <div className={classes.dialogHeader}>
          <IconButton onClick={handleCloseDialog}>
            <CloseIcon style={{ color: theme.palette.neutrals.low.medium }} />
          </IconButton>
        </div>
        <div className={classes.dialogContent}>
          <>
            <img src={infoSvg} alt="info" />
          </>
          <div className={classes.dialogTitle}>{title}</div>
          <div className={classes.dialogDescription}>{description}</div>
        </div>
        <DialogActions className={classes.dialogActions}>
          {children}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export { DialogImagine };
